import { makeAutoObservable, runInAction } from 'mobx';

import {cmApi } from '@src/api';
import type { CmApi, OrganizationTypeDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

type OrganizationTypeDtoDefId = OrganizationTypeDto & { id: number };

class OrganizationTypeStore {
  orgTypes: OrganizationTypeDtoDefId[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (signal?: AbortSignal): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.organizationTypes.getOrganizationTypes({ signal: signal });

    runInAction(() => {
      this.orgTypes = data?.map((org) => ({ ...org, id: org.code ?? -1 })) ?? [];
    });
    preloaderStore.preloader(false);
  };
}

export const organizationTypeStore = new OrganizationTypeStore({ api: cmApi });
